import { CardFooter } from "./card-footer.js";
import { styles } from "./card-footer.styles.js";
import { template } from "./card-footer.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-card-footer>
 */
export const definition = CardFooter.compose({
    name: `${DesignSystem.prefix}-card-footer`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=card-footer.definition.js.map